export default "__VITE_ASSET__DXzvKpr2__"